import { ProductIndexItemInterface } from "../interfaces/apiV2/shared/ProductIndexItemInterface";
import { LanguageInterface } from "../interfaces/shared/LanguageInterface";
import { TranslationsInterface } from "../interfaces/shared/TranslationsInterface";

export interface SimpleProduct {
    id: number;
    identifier: string;
    title: string;
    image?: string;
    price?: string;
    specifications?: Array<{
        label: string;
        value: string;
    }>;
    similarProductsSpecification?: {
        label: string;
        value: string;
    };
    isArchived?: boolean;
    connection?: string;
    originalProduct: ProductIndexItemInterface;
}

const getProductTitle = (product: ProductIndexItemInterface): string =>
    product.label ?? "";

const getProductPrice = (
    product: ProductIndexItemInterface,
): string | undefined => product.prices?.value;

export function convertProductToListFormat(
    product: ProductIndexItemInterface,
    _activeLanguage: LanguageInterface | null,
): SimpleProduct {
    return {
        id: product.id,
        identifier: product.identifier,
        title: getProductTitle(product),
        image: product.image ?? undefined,
        isArchived: false,
        price: getProductPrice(product),
        specifications: [],
        connection: product.connection ?? undefined,
        originalProduct: product,
    };
}

export function convertProductToGridFormat(
    product: ProductIndexItemInterface,
    _activeLanguage: LanguageInterface | null,
    _translations?: TranslationsInterface,
): SimpleProduct {
    const specifications =
        product.productAttributes
            ?.map((attr) => ({
                label: attr.label ?? "",
                value: attr.value,
            }))
            .filter((spec) => spec.value) ?? [];

    return {
        id: product.id,
        identifier: product.identifier,
        title: getProductTitle(product),
        image: product.image ?? undefined,
        isArchived: false,
        price: getProductPrice(product),
        specifications,
        originalProduct: product,
        connection: product.connection ?? undefined,
    };
}
